import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    Chip,
    Avatar,
    Divider,
    styled,
    StepConnector,
    stepConnectorClasses,
    StepLabel
} from "@mui/material";


export const StyledCard = styled(Card)`
  border-radius: 8px;
  box-shadow: 5px;
`;
export const StyledAvatar = styled(Avatar)`
  width: 48px;
  height: 48px;
  border-radius:0px;
  background-color:#fafafa;
  color:#616161;
`;

export const StyledChip = styled(Chip)`
  background: #e3f1e3;
  color: #4f874f;
  border: 1px solid #4f874f;
`;

export const CustomStepIconRoot = styled('div')(({ theme, ownerState, color }) => ({
    display: 'flex',
    height: 22,
    width: 22,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    // backgroundColor: color,
    border: color ? `2px solid ${color}` : 'none',
    // color: color,
    zIndex: 1,

}));

export const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.line}`]: {
        height: 24,
        borderLeftWidth: 2,
        borderColor: '#e0e0e0',
    },
}));

export const CustomStepLabel = styled(StepLabel)(({ theme, stepColor }) => ({
    '& .MuiStepLabel-label': {
        fontSize: '14px',
        color: stepColor,
    },
    '& .MuiStepLabel-description': {
        fontSize: '12px',
        color: stepColor,
    },
}));